export default __webpack_public_path__ + "static/media/reply.be992b1e.JPG";